import { Components, Theme } from '@mui/material';

export const MuiMenu: Components<Theme>['MuiMenu'] = {
  styleOverrides: {
    root: {
      marginTop: '8px',
    },
    paper: {
      borderRadius: '8px',
      border: '1px solid #cfd8dc',
      background: '#f2f4f5',
      boxShadow: '0px 0px 64px 0px rgba(25, 181, 210, 0.12)',
    },
  },
};
